const matcher = window.matchMedia(`(min-width: 1024px)`);

const heroProductAdd = () => ({
  drawerSide: '',
  stickyButtonVisible: false,

  get selectedVariantsIds() {
    return this.selectedVariants.map((variant) => variant.id).join(',');
  },

  init() {
    this.setupStickyButton();

    this.parentSelectedVariants = this.selectedVariants;

    this.$watch('selectedVariantsIds', (val) => {
      this.parentSelectedVariants = this.selectedVariants;

      if (this.selectedVariants.length === 1) {
        const id = val.replace('gid://shopify/ProductVariant/', '');
        const url = new URL(window.location.href);
        if (url.searchParams.get('variant') !== id) {
          url.searchParams.set('variant', id);
          window.history.pushState({}, '', url.toString());
        }
      }
    });

    this.loadVariantFromUrl();

    // if (this.afterpayPlacement) {
    //   this.$refs.afterpayTarget.appendChild(this.afterpayPlacement);
    // }

    // this.$watch('afterpayPlacement', (val) => {
    //   if (val) {
    //     this.$refs.afterpayTarget.appendChild(val);
    //   }
    // });

    // On Gift card page mobile, show Sticky Gift card button only when the main Gift card button is initiated.
    if (location.href.includes("giftcard")) {
      this.checkElementExists(".GiftWizard-gift-button", 20).then((result) => {
        if (result) {
          const giftCardButtonSticky = document.querySelector('.GiftWizard-gift-button-sticky');
          if (giftCardButtonSticky) {
            giftCardButtonSticky.style.display = "block";
          }
        }
      });
    }

  },
  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  },

  destroy() {
    this.intersectionObserver?.disconnect();
  },
  async handleButtonClick() {
    const { stateBase } = this;
    const userStatus = this.getCookie('userStatusFacebook');

    if(userStatus == "VIP") {
      await this.addToCart({ isFacebook: true });
      this.isWorking = false;
      return
    }
    if (stateBase === 'available' || stateBase === 'pre-order' || stateBase === 'back-order') {
      await this.addToCart();
      this.isWorking = false;
    }

    if (stateBase === 'app-exclusive') {
      window.open('https://wn4uoivx.tapc.art');
    }

    if (stateBase === 'sold-out-notify' || stateBase === 'coming-soon') {
      this.$dispatch('open-quick-add-drawer', {
        product: this.shopifyData,
        selectedOptions: this.selectedOptions,
      });
    }

    if (stateBase === 'many-variants') {
      const missingOption = Object.entries(this.selectedOptions).find(
        ([, value]) => value === ''
      )?.[0];
      this.$root
        .querySelector(`[data-option-name="${missingOption}"]`)
        .scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
    }
  },
  async handleStickyGiftButtonClick() {
    const sendAsGiftButton = document.querySelector('.GiftWizard-gift-button');
    if (sendAsGiftButton) {
      sendAsGiftButton.click();
    }
  },
  checkElementExists(element, timeout = Infinity) {
    let startTime = Date.now();
    return new Promise((resolve) => {
      const intervalId = setInterval(() => {
        if (document.querySelector(element)) {
          clearInterval(intervalId);
          resolve(true);
        } else if (Date.now() - startTime >= timeout * 1000) {
          clearInterval(intervalId);
          resolve(false);
        }
      }, 100);
    });
  },
  handleDrawerOpen(e) {
    this.drawerSide = matcher.matches ? 'right' : 'bottom';

    e.target
      .closest('button')
      .parentElement.querySelector('dialog')
      .showModal();
  },

  loadVariantFromUrl() {
    const url = new URL(window.location.href);
    const variantId = url.searchParams.get('variant');

    if (variantId) {
      const variant = this.product.variants.find(
        (variant) => variant.id === `gid://shopify/ProductVariant/${variantId}`
      );

      if (variant) {
        Object.assign(
          this.selectedOptions,
          Object.fromEntries(
            variant.selectedOptions.map(({ name, value }) => [name, value])
          )
        );
        this.normalizeOptionsAndVariants(Object.entries(this.selectedOptions));
      }
    }
  },

  handlePopstate() {
    this.loadVariantFromUrl();
  },

  setupStickyButton() {
    this.intersectionObserver = new IntersectionObserver(([entry]) => {
      this.stickyButtonVisible = !entry.isIntersecting;
    }, {});

    this.intersectionObserver.observe(this.$refs.button);
  },
});

export default heroProductAdd;
